import agentReducer from './AgentReducer';
export * from './AgentActions';
export default agentReducer;